import React from "react";
import { Row, Col, Typography } from "antd";
const { Text, Title } = Typography;
export default function CatalogueDetails({ text, row, index }) {
  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <Title level={5} style={{ margin: 0 }}>
              {text?.name}
            </Title>
          </Col>
        </Row>
        <Row>
          <Col>
            <Text type="secondary">{text?.products} products</Text>
          </Col>
        </Row>

        <Row>
          <Col>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {text?.genaratedBy &&
                `${row.status == "draft" ? "Started by" : "Generated by"} ${
                  text?.genaratedBy
                }`}
              {text?.generatedAt &&
                ` at ${text?.generatedAt
                  // row.status == "draft" ? text?.generatedAt : text?.updatedAt
                }`}
              <br />
              {row.status == "draft" &&
                text?.updatedAt &&
                ` Last updated by ${text?.updatedBy || ""}  at ${
                  text?.updatedAt
                }`}
              {/* {text?.updatedBy && }
              {text?.updatedAt && ``} */}
            </Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
